// File: src/components/providers/theme-provider.tsx
// Purpose: Theme provider component for InstaDev
// InstaDev - Theme Provider


import * as React from 'react'
import { useThemeStore } from '@/lib/stores/theme-store'

export function ThemeProvider({ children }: { children: React.ReactNode }) {
  const { theme, setEffectiveTheme } = useThemeStore()

  React.useEffect(() => {
    const root = window.document.documentElement

    const applyTheme = (newTheme: 'light' | 'dark') => {
      root.classList.remove('light', 'dark')
      root.classList.add(newTheme)
      setEffectiveTheme(newTheme)
    }

    if (theme === 'system') {
      const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)')
      
      const handleChange = () => {
        applyTheme(mediaQuery.matches ? 'dark' : 'light')
      }

      handleChange()
      mediaQuery.addEventListener('change', handleChange)

      return () => mediaQuery.removeEventListener('change', handleChange)
    } else {
      applyTheme(theme)
    }
  }, [theme, setEffectiveTheme])

  return <>{children}</>
}